import React, { useState } from "react";
import { ModalComponent } from "../../../components/Modal.components";
import { Boxed } from "../../../components/Boxed.components";
import { PageTitle } from "../../../components/style";
import { Button } from "../../../components/Button.components";
import { Text } from "../../../components/Text.components";
import { Uploader } from "../../../components/Uploader.components";
import { Grid } from "../../../components/Grid.components";
import { AsyncSelect, Input } from "../../../components/Input.components";

export const CreateModal = (props) => {

  // State props
  const { createDepartmentModal, isLoading } = props;

  // Dispatch props
  const { closeModal, form, createDepartment } = props;
  const { getFieldProps, getFieldError, validateFields, getFieldValue } = form;
  const organization = localStorage.getItem("dapproval_app_organisation");
  const onSubmit = () => {
    validateFields((error, value) => {
      if (!error) {
        const payload = {
        description: value.departmentname.trim(),
        organizations: [organization],
        
        };
        createDepartment(payload);
      }
    });
  };

  return (
    <ModalComponent
      show={createDepartmentModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">Add a new Department</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
          <Button
            margin="0 0 0 auto"
            progress={isLoading}
            disabled={isLoading}
            onClick={onSubmit}
          >
            Add Department
          </Button>
        </Boxed>
      }
    >

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Department Name"
            placeholder="Enter department name..."
            error={
              getFieldError("departmentname") ? "Department name is required" : null
            }
            {...getFieldProps("departmentname", {
              initialValue: "",
              rules: [{ required: true }],
            })}
          />
        </Boxed>

    </ModalComponent>
  );
};
